<template>
  <EchartsLayout :option="option"></EchartsLayout>
</template>

<script>
import {
  getCacheOrRequest,
  replaceZhenAndJieDao,
  echatsTextFontSize,
} from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "get",
        url: `/nh/getOrderNumByTown`,
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              arr.push([item.divisionName, item.allNum]);
            });

          arr = arr.filter((item) => {
            return item[0] ? true : false;
          });

          arr = replaceZhenAndJieDao(arr);
          // 更新配置
          this.option = {
            grid: {
              containLabel: true,
              top: 120,
              left: 0,
              right: 0,
              bottom: 100,
            },
            series: [
              {
                name: "补贴",
                type: "bar",
                showItemStyle: true,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "RGBA(191, 226, 9, 1)" },
                      { offset: 1, color: "RGBA(42, 181, 0, 1)" },
                    ],
                    globalCoord: false,
                  },
                  borderRadius: 50,
                },
                barWidth: 100,
                markPoint: {
                  data: [
                    { type: "max", name: "最大值" },
                    { type: "min", name: "最小值" },
                  ],
                  label: {
                    ...echatsTextFontSize,
                  },
                },
              },
            ],
            title: { text: "居家养老服务总订单数（单位：单）", ...echatsTextFontSize },
            xAxis: {
              type: "category",
              axisLabel: {
                ...echatsTextFontSize,
              },
            },
            yAxis: {
              axisLabel: {
                ...echatsTextFontSize,
              },
            },
            dataset: {
              source: [["镇街", "居家订单总数"], ...arr],
            },
          };
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
